import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_HIGH } from "lexical";
import { useEffect } from "react";
import { useFlag } from "../../../../server/optimizely";
import { $createStylableButtonNode } from "../nodes/stylable-button-mui";
import { INSERT_STYLABLE_BUTTON_COMMAND, type StylableButtonCommand } from "../types/commands";
import { $insertNode } from "../utils/insert-node";
import { $selectionOrStart } from "../utils/selection-or-start";

export function StylableButtonPlugin(): null {
  const [editor] = useLexicalComposerContext();
  const [editor_focus_fix] = useFlag("cha_4472_editor_focus_fix_for_links_and_surveys");

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_STYLABLE_BUTTON_COMMAND,
        (data: StylableButtonCommand) => {
          const selection = editor_focus_fix ? $selectionOrStart() : $getSelection();

          if (!$isRangeSelection(selection)) {
            return false;
          }
          const node = $createStylableButtonNode(
            editor._headless,
            data.text,
            data.url,
            data.buttonType,
            data.fullWidth,
            data.format,
          );
          $insertNode(node);

          return true;
        },
        COMMAND_PRIORITY_HIGH,
      ),
    [editor, editor_focus_fix],
  );

  return null;
}
